import React, { Component } from "react";
import CommonServices from "../../services/axioServices/apiServices/CommonServices.js";
import ItemMasterServices from "../../services/axioServices/apiServices/ItemMasterServices.js";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPen, faSpinner, faTrash } from "@fortawesome/free-solid-svg-icons";
import { isValidForm } from "../../utils/validation/CommonValidator.js";
import { CommonValidationMessages } from "../../utils/Messages.js";
import SwalServices from "../../services/swalServices/SwalServices.js";
import ValidationText from "../../utils/validation/ValidationText.js";

class TransportCourierMaster extends Component {
  constructor(props) {
    super(props);
    this.commonServices = new CommonServices();
    this.SwalServices = new SwalServices();
    this.itemMasterServices = new ItemMasterServices();
    this.state = {
      _id: "",
      isGridView: true,
      isLoading: false,
      transportCourierList: [],
      totalCount: 0,
      searchByItemName: "",
      tableStatus: "",
      transportCourierDetails: {
        ID: 0,
        transportName: "",
        transportCode: "",
        personName: "",
        address: "",
        mobileNo: "",
        telephone: "",
        transportId: "",
        webSite: "",
      },
      isEditing: false,
      validationRules: {
        transportName: [
          {
            type: "require",
            message: CommonValidationMessages.FieldRequired.replace(
              "{0}",
              "transport name"
            ),
          },
        ],
      },
      validState: {
        isValid: true,
        error: {},
      },
    };
  }

  componentDidMount() {
    this.getAllTransportCourier(this.state.searchByItemName);
  }

  getAllTransportCourier = (searchname) => {
    this.setState({ tableStatus: "Loading..." })
    this.commonServices.getAllTransportCourier(searchname).then((response) => {
      if (response.statusCode === 200 && response.responseData != null) {
        if (response.responseData.length === 0) {
          this.setState({ tableStatus: "No Record Found" })
        } else {
          this.setState({ tableStatus: "" })
        }
        let count = response.responseData.length;
        this.setState({ totalCount: count });
        this.setState({ transportCourierList: response.responseData });
      } else {
        this.setState({ tableStatus: "" })
        this.SwalServices.Error(response.Message);
      }
    });
  };

  closeGridView = () => {
    this.setState({ isGridView: false });
  };

  openGridView = () => {
    this.resetForm();
    this.setState({ isGridView: true, isEditing: false });
  };

  resetForm = () => {
    let validState = this.state.validState;
    validState.isValid = true;
    validState.error = {};
    let details = this.state.transportCourierDetails;
    details.ID = 0;
    details.transportName = "";
    details.transportCode = "";
    details.transportId = "";
    details.personName = "";
    details.telephone = "";
    details.mobileNo = "";
    details.webSite = "";
    details.address = "";
    this.setState({ transportCourierDetails: details, _id: "", validState: validState, searchByItemName: "", tableStatus: "", isEditing: false },
      () => { this.getAllTransportCourier(this.state.searchByItemName); }
    );
  };

  searchByItemName = (event, name) => {
    let value = event.target.value;
    this.setState({ searchByItemName: value }, () => {
      this.getAllTransportCourier(this.state.searchByItemName);
    });
  };

  handleChange = (event, name) => {
    let value = event.target.value;
    let details = this.state.transportCourierDetails;
    details[name] = value.toUpperCase();
    this.setState({ transportCourierDetails: details });
  };

  addEditTransportCourier = () => {
    let isValidAllFields = this.isValidAllFields();
    if (isValidAllFields) {
      this.setState({ isLoading: true }, () => {
        let request = this.state.transportCourierDetails;
        if (this.state._id && this.state._id !== "") {
          request._id = this.state._id;
        } else {
          delete request._id;
        }
        this.itemMasterServices
          .addEditTransportCourier(request)
          .then((response) => {
            if (response.statusCode === 200 && response.responseData != null) {
              this.SwalServices.Success(response.Message);
              this.resetForm();
              this.setState({ isGridView: true, searchByItemName: '', isLoading: false }, () => {
                this.getAllTransportCourier(this.state.searchByItemName);
              });
            } else {
              this.SwalServices.Error(response.Message);
              this.setState({ isLoading: false });
            }
          });
      });
    }
  };

  isValidAllFields = () => {
    const newValidState = isValidForm(
      this.state.transportCourierDetails,
      this.state.validationRules,
      this.state.validState
    );
    this.setState({ validState: newValidState });
    return newValidState.isValid;
  };

  getTransportCourierById = (transport) => {
    let details = this.state.transportCourierDetails;
    details.ID = transport.ID;
    details.transportCode = transport.transportCode;
    details.transportName = transport.transportName;
    details.personName = transport.personName;
    details.address = transport.address;
    details.mobileNo = transport.mobileNo;
    details.telephone = transport.telephone;
    details.transportId = transport.transportId;
    this.setState(
      { transportCourierDetails: details, _id: transport._id },
      () => {
        this.setState({ isGridView: false, isEditing: true });
      }
    );
  };

  deleteTransportCourierById = (id) => {
    this.itemMasterServices.deleteTransportCourierById(id).then((response) => {
      if (response.statusCode === 200 && response.responseData != null) {
        this.SwalServices.Success(response.Message);
        this.getAllTransportCourier(this.state.searchByItemName);
      } else {
        this.SwalServices.Error(
          response.Message
        );
      }
    });
  };

  render() {
    return (
      <div className="transportMaster-page">
        {this.state.isGridView === true ? (
          <>
            <div className="item-search !mb-2">
              <div className="item-grp">
                <div className="item-search-box w-[50%]">
                  <label>Transport name</label>
                  <input
                    className="inputFocus"
                    type="text"
                    id="searchByItemName"
                    name="searchByItemName"
                    autoComplete="off"
                    value={this.state.searchByItemName}
                    onChange={(event) =>
                      this.searchByItemName(event, "searchByItemName")
                    }
                  />
                </div>
              </div>
              <button className="add-btn mt-3" onClick={() => this.closeGridView()}>
                Add new Item
              </button>
            </div>
            <div className="itemList-table">
              <p className="mb-[3px] text-[15px] font-medium text-[#474747]">Total Count :- {this.state.totalCount}</p>
              <div className="table-container" style={{ height: 'calc(100vh - 205px)' }}>
                <table className="itemList">
                  <thead>
                    <tr>
                      <td style={{ width: '30%' }}>Transporter Name</td>
                      <td style={{ width: '15%' }}>Contact Person</td>
                      <td style={{ width: '15%' }}>Telephone</td>
                      <td style={{ width: '15%' }}>Mobile</td>
                      <td style={{ width: '15%' }}>Transport ID</td>
                      <td style={{ width: '10%', textAlign: 'center' }}>Action</td>
                    </tr>
                  </thead>
                  {this.state.transportCourierList &&
                    this.state.transportCourierList.length > 0 ? (
                    this.state.transportCourierList.map((item, key) => (
                      <tbody key={key}>
                        <tr>
                          <td>{item.transportName}</td>
                          <td>{item.personName}</td>
                          <td>{item.telephone}</td>
                          <td>{item.mobileNo}</td>
                          <td>{item.transportId}</td>
                          <td style={{ textAlign: 'center' }}>
                            <button
                              className="search-btn"
                              onClick={() => this.getTransportCourierById(item)}
                            >
                              <FontAwesomeIcon icon={faPen} />
                            </button>
                            <button
                              className="cancel-btn"
                              onClick={() =>
                                this.deleteTransportCourierById(item._id)
                              }
                            >
                              <FontAwesomeIcon icon={faTrash} />
                            </button>
                          </td>
                        </tr>
                      </tbody>
                    ))
                  ) : this.state.transportCourierList &&
                    this.state.transportCourierList.length === 0
                    && this.state.tableStatus !== "" ? (
                    <tr>
                      <td colSpan={7} style={{ textAlign: "center", fontSize: "16px" }}>
                        {this.state.tableStatus}
                      </td>
                    </tr>
                  ) : this.state.transportCourierList &&
                    this.state.transportCourierList.length === 0
                    && this.state.tableStatus === "" ? null : ""}
                </table>
              </div>
            </div>
          </>
        ) : null}
        {this.state.isGridView === false ? (
          <div className="item-listing">
            <div className="item-form">
              <div className="form-table">
                <div className="item-grp grid grid-cols-2 !gap-2.5 mb-3" >
                  <div className="input-grp">
                    <label>Transport Name</label>
                    <input
                      className={`inputFocus ${this.state.validState?.error?.transportName ? "errorInput" : ""}`}
                      type="text"
                      id="transportName"
                      name="transportName"
                      autoComplete="off"
                      value={this.state.transportCourierDetails.transportName}
                      onChange={(event) =>
                        this.handleChange(event, "transportName")
                      }
                    />
                    {/* <ValidationText
                      error={this.state.validState.error.transportName}
                    /> */}
                  </div>
                  <div className="itemInner-grp grid !grid-cols-2 !gap-2.5">
                    <div className="input-grp">
                      <label>Contact Person</label>
                      <input
                        className="inputFocus"
                        type="text"
                        id="personName"
                        name="personName"
                        autoComplete="off"
                        value={this.state.transportCourierDetails.personName}
                        onChange={(event) =>
                          this.handleChange(event, "personName")
                        }
                      />
                    </div>
                    <div className="input-grp">
                      <label>Mobile</label>
                      <input
                        className="inputFocus"
                        type="text"
                        id="mobileNo"
                        name="mobileNo"
                        autoComplete="off"
                        value={this.state.transportCourierDetails.mobileNo}
                        onChange={(event) => this.handleChange(event, "mobileNo")}
                      />
                    </div>
                  </div>
                </div>
                <div className="item-grp grid !grid-cols-2 !gap-2.5 mb-3">
                  <div className="itemInner-grp grid !grid-cols-2 !gap-2.5">
                    <div className="input-grp">
                      <label>Telephone</label>
                      <input
                        className="inputFocus"
                        type="text"
                        id="telephone"
                        name="telephone"
                        autoComplete="off"
                        value={this.state.transportCourierDetails.telephone}
                        onChange={(event) =>
                          this.handleChange(event, "telephone")
                        }
                      />
                    </div>
                    <div className="input-grp">
                      <label>Transport ID</label>
                      <input
                        className="inputFocus"
                        type="text"
                        id="transportId"
                        name="transportId"
                        autoComplete="off"
                        value={this.state.transportCourierDetails.transportId}
                        onChange={(event) =>
                          this.handleChange(event, "transportId")
                        }
                      />

                    </div>
                  </div>
                  <div className="input-grp">
                    <label>Tracking Website</label>
                    <input
                      className="inputFocus"
                      type="text"
                      id="webSite"
                      name="webSite"
                      autoComplete="off"
                      value={this.state.transportCourierDetails.webSite}
                      onChange={(event) => this.handleChange(event, "webSite")}
                    />

                  </div>
                </div>
                <div className="item-grp">
                  <div className="input-grp">
                    <label>Address</label>
                    <textarea
                      rows={5}
                      type="text"
                      id="address"
                      name="address"
                      autoComplete="off"
                      value={this.state.transportCourierDetails.address}
                      onChange={(event) => this.handleChange(event, "address")}
                    />

                  </div>
                </div>
              </div>
              <div className="btn-grp mt-3.5">
                {this.state.isEditing === true ? (
                  <button
                    className="add-btn"
                    disabled={this.state.isLoading}
                    onClick={() => this.addEditTransportCourier()}
                  >
                    {this.state.isLoading ? <FontAwesomeIcon icon={faSpinner} className="loader" /> : "Save"}
                  </button>
                ) : (
                  <button
                    className="add-btn"
                    disabled={this.state.isLoading}
                    onClick={() => this.addEditTransportCourier()}
                  >
                    {this.state.isLoading ? <FontAwesomeIcon icon={faSpinner} className="loader" /> : "Add"}
                  </button>
                )}
                <button
                  className="cancel-btn !ml-0"
                  disabled={this.state.isLoading}
                  onClick={() => this.openGridView()}
                >
                  Cancel
                </button>
              </div>
            </div>
          </div>
        ) : null}
      </div>
    );
  }
}

export default TransportCourierMaster;
